// Transport-owned lease. Never inferred from URL, storage, or authentication state.
let active = false;
export const isPublicSimulationRuntime = () => active;
export function enterPublicSimulationRuntime() {
  if (active) throw new Error('simulation.transport.already_installed');
  active = true;
  return () => { active = false; };
}
export const publicSimulationSaasContext = Object.freeze({tenantId: '', organizationId: '', workspaceId: 'default'});
